/**
 * Valuations Page - Migrated to use EntitiesList
 *
 * This page now uses the generic EntitiesList component with
 * Valuations-specific configuration for a standardized experience.
 */

import React from "react";

// Generic EntitiesList component and entity configurations
import EntitiesList from "../components/entities/EntitiesList";
import ValuationsConfig from "../components/entities/valuations/ValuationsConfig";
import ValuationsColumns from "../components/entities/valuations/ValuationsColumns";
import * as ValuationsMetrics from "../components/entities/valuations/ValuationsMetrics";

// Custom components specific to Valuations
import ValuationTypeDropdown from "../components/ui/ValuationTypeDropdown";

// API hooks
import { useValuations } from "../hooks/useApi";

/**
 * Valuations Page Component
 *
 * Uses the generic EntitiesList with Valuations-specific configuration
 * to provide a consistent, standardized experience.
 */
function Valuations() {
  // API hooks for valuations data
  const {
    items: valuations = [],
    loading,
    error,
    refresh: refetch,
    clearError,
  } = useValuations();

  // Custom Header Actions component for Valuations
  const ValuationsHeaderActions = () => <ValuationTypeDropdown />;

  // Custom Empty State Actions for Valuations
  const ValuationsEmptyStateActions = () => <ValuationTypeDropdown />;

  return (
    <EntitiesList
      // Entity configuration
      entityConfig={ValuationsConfig}
      entityColumns={ValuationsColumns}
      entityMetrics={ValuationsMetrics}
      // Data and state
      entities={valuations}
      loading={loading}
      error={error}
      // API functions
      refreshFunction={refetch}
      clearErrorFunction={clearError}
      // Custom components
      HeaderActions={ValuationsHeaderActions}
      EmptyStateActions={ValuationsEmptyStateActions}
      // Layout preferences
      layout="table"
    />
  );
}

export default Valuations;
